// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import constants from "@store/constants";
import setFieldValue from "@store/Framework/Store/Greif/Components/RecommendedProductRequestForm/Handlers/SetFieldValue";
import { RecommendedProductRequestFormContext } from "@store/Library/Widgets/RecommendedProductRequest/RecommendedProductRequestForm";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    isRequired = "isRequired",
    isDisabled = "isDisabled",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isRequired]: boolean;
        [fields.isDisabled]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    session: getSession(state),
    lastName: state.greif.components.recommendedProductRequestForm.fieldValues["lastName"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface LastNameStyles {
    lastNameTextField?: TextFieldPresentationProps;
}

export const lastNameStyles: LastNameStyles = {};

const styles = lastNameStyles;

const LastName: FC<Props> = ({ fields, session, lastName, setFieldValue }) => {
    const { isRequired, isDisabled } = fields;
    const recommendedProductRequestFormContext = useContext(RecommendedProductRequestFormContext);
    const [lastNameErrorMessage, setLastNameErrorMessage] = useState("");

    const lastNameLabel = translate("Last Name");

    useEffect(() => {
        if (session) {
            setFieldValue({ key: "lastName", value: session.lastName });
        }
    }, [session]);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.lastName = validateLastName;
        if (typeof lastName !== "undefined") {
            validateLastName();
        }
    }, [lastName]);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.lastName = validateLastName;
    }, [isRequired]);

    const validateLastName = () => {
        const errorMessage = isRequired && !lastName ? siteMessage("Field_Required", lastNameLabel).toString() : "";
        setLastNameErrorMessage(errorMessage);
        return !errorMessage;
    };

    const lastNameChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "lastName", value: event.target.value });
    };

    return (
        <TextField
            {...styles.lastNameTextField}
            label={lastNameLabel}
            value={lastName || ""}
            onChange={lastNameChangeHandler}
            required={isRequired}
            error={lastNameErrorMessage}
            disabled={isDisabled}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(LastName),
    definition: {
        displayName: "Last Name",
        group: constants.widgetGroup.recommendedProductRequest,
        icon: "input-pipe",
        allowedContexts: [constants.pageType.recommendedProductRequest],
        fieldDefinitions: [
            {
                name: fields.isDisabled,
                displayName: "Disabled?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
